var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pr text-center mt0-ipmt file-wrap" },
    [
      _vm.showDelete
        ? _c(
            "i",
            {
              staticClass: "file-del w20 h20 right-top mask hand opah0",
              on: {
                click: function ($event) {
                  return _vm.$emit("delete")
                },
              },
            },
            [
              _c("yxt-svg", {
                staticClass: "pa pa-center c-f",
                attrs: {
                  width: "20px",
                  height: "20px",
                  "icon-class": "common_close",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "border-1 border-f5f5f5 border-solid border-box text-center radius4 over-hidden pr hand bg-gray-2",
          style: { height: _vm.imageHeight },
        },
        [
          _vm.file.upload && _vm.file.upload.status === "failed"
            ? _c("yxt-svg", {
                attrs: {
                  width: "54px",
                  height: "52x",
                  "icon-class": "hwk-unknown-file-type",
                  "remote-url": _vm.svgUrl,
                },
              })
            : _vm.isDefaultIconUsed
            ? _c(
                "i",
                { staticClass: "wline d-block bg-center hline pr" },
                [
                  _c("yxtf-svg", {
                    staticClass: "pa pa-center",
                    attrs: {
                      width: "54px",
                      height: "54px",
                      "icon-class": "icons/f_kng-" + _vm.file.fileSubType,
                    },
                  }),
                ],
                1
              )
            : [
                _vm.file.viewUrl
                  ? _c(
                      "yxt-image",
                      {
                        staticClass: "d-block text-8c bg-gray-2 wline hline",
                        attrs: {
                          src: _vm.getFilteredImg(_vm.file.viewUrl),
                          fit: "contain",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "image-slot font-size-12",
                            attrs: { slot: "placeholder" },
                            slot: "placeholder",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("pc_o2o_lbl_loading")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "image-slot font-size-24",
                            attrs: { slot: "error" },
                            slot: "error",
                          },
                          [
                            _c("i", {
                              staticClass: "yxtf-icon-picture-outline",
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.file.fileType === "audio" && _vm.file.status === 1
                  ? _c("i", { staticClass: "audio-bg d-block wline hline" })
                  : _vm._e(),
              ],
          ["doc", "image", "zip", "audio", "video"].includes(_vm.file.fileType)
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.file.upload ||
                        _vm.file.upload.status === "success",
                      expression:
                        "!file.upload || file.upload.status === 'success'",
                    },
                  ],
                  staticClass:
                    "layout-flex layout-align-center layout-justify-center pa right-top mask wline hline opah0 opah1",
                },
                [
                  _vm.file.fileType !== "zip" && _vm.viewBtnIsShow
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "h24 layout-flex layout-align-center color-white hand",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("preview", _vm.file)
                            },
                          },
                        },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "pc_biz_imgcropper_btn_preview" /* 预览 */
                                ),
                                placement: "top",
                              },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "v-mid mr4",
                                attrs: {
                                  width: "16px",
                                  height: "16px",
                                  "icon-class": "view",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.downloadBtnIsShow
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "h24 layout-flex layout-align-center color-white hand",
                          class: { ml20: _vm.file.fileType !== "zip" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("download", _vm.file)
                            },
                          },
                        },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "pc_biz_import_btn_download\n" /* 下载 */
                                ),
                                placement: "top",
                              },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "v-mid mr4",
                                attrs: {
                                  width: "16px",
                                  height: "16px",
                                  "icon-class": "download-center",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.file.status === 1 || _vm.file.fileType === "image") &&
                  _vm.joinKnglibBtnIsShow
                    ? _c("div", {
                        staticClass:
                          "h24 layout-flex layout-align-center color-white hand ml20 lhnormal",
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.file.upload && _vm.file.upload.status === "uploading"
            ? _c(
                "div",
                { staticClass: "pa bottom0 left0 right0" },
                [
                  _c("yxt-progress", {
                    attrs: {
                      "stroke-width": 6,
                      percentage: _vm.file.upload.progress * 100,
                      "fit-width": true,
                      "show-text": false,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      !_vm.fileNameHidden
        ? _c(
            "yxt-tooltip",
            {
              attrs: {
                "open-filter": "",
                content: _vm.file.name,
                placement: "top",
              },
            },
            [
              _c("div", { staticClass: "ellipsis mt8 text-center lh22" }, [
                _vm._v(_vm._s(_vm.file.name)),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.fileStatusHidden
        ? _c("div", { staticClass: "lh20" }, [
            _c(
              "div",
              {
                staticClass:
                  "hline layout-flex layout-align-center layout-justify-center",
              },
              [
                _vm.file.upload && _vm.file.upload.status === "failed"
                  ? [
                      _c("yxt-svg", {
                        staticClass: "mr2",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "message-error",
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "font-size-12 yxtf-color-danger ellipsis",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.file.upload.msg) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  : _vm.file.transcode === "transcoding"
                  ? [
                      _c("yxt-svg", {
                        staticClass: "mr2 flex-shrink-0",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "o2o-hwk-reference-loading",
                        },
                      }),
                      _c("div", { staticClass: "font-size-12 color-gray-8" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "pc_o2o_transcoding_no_preview" /* 转码中，暂不支持预览 */
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  : _vm.file.transcode === "failed"
                  ? [
                      _c("yxt-svg", {
                        staticClass: "mr2 color-gray-8",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "icons/close-circle-o",
                        },
                      }),
                      _c("div", { staticClass: "font-size-12 color-gray-8" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("pc_o2o_lbl_transcodefail" /* 转码失败 */)
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }